import type { KeyboardEvent } from 'react';
import { MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
  categories,
  severityLabels,
  statusLabels,
  typeLabels,
  type DesignTicket,
} from '../lib/ticketMap';

export function TicketRow({
  ticket,
  highlight = false,
  active = false,
  onOpen,
}: {
  ticket: DesignTicket;
  highlight?: boolean;
  active?: boolean;
  onOpen?: () => void;
}) {
  const navigate = useNavigate();
  const category = categories.find((c) => c.id === ticket.type) ?? categories[0];
  const Icon = category.icon;
  const handleOpen = onOpen ?? (() => navigate(`/tickets/${ticket.id}`));

  const onKeyDown = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleOpen();
    }
  };

  return (
    <article
      aria-label={`Открыть обращение #${ticket.number}: ${ticket.title}`}
      aria-pressed={active}
      className={`ticket ${highlight ? 'highlight' : ''} ${active ? 'active' : ''} interactive`}
      role="button"
      tabIndex={0}
      onClick={handleOpen}
      onKeyDown={onKeyDown}
    >
      <div className="ticket-num">#{ticket.number}</div>
      <div className="ticket-main">
        <h4>{ticket.title}</h4>
        <div className="ticket-meta">
          <span>
            <Icon size={13} />
            {typeLabels[ticket.type]}
          </span>
          <span>·</span>
          <span>
            <MessageSquare size={12} />
            {ticket.comments}
          </span>
          <span>·</span>
          <span>{ticket.updatedAt}</span>
        </div>
      </div>
      <div className="ticket-state">
        <span className={`status status-${ticket.status}`}>{statusLabels[ticket.status]}</span>
        <span className={`sev sev-${ticket.severity.toLowerCase()}`}>{ticket.severity}</span>
        <span className="sr-only">{severityLabels[ticket.severity]}</span>
      </div>
    </article>
  );
}
